export default (function menuInit() {
    const menu = {
        toggle() {
            const $menu = $('.js--menu');
            $('.js--menu_button').on('click', () => {
                $menu.toggleClass('menu--active');
            });
            $('.js--overlay').on('click', () => {
                $menu.removeClass('menu--active');
            });
        },

        stickyMenu() {
            if (window.matchMedia('(min-width: 1200px)').matches) {
                if ($(document).scrollTop() > 600) {
                    $('#header').addClass('sticky');
                } else {
                    $('#header').removeClass('sticky');
                    $('#header .nav').css('top', 0);
                }
            } else if (window.matchMedia('(max-width: 1999px)').matches) {
                if ($(document).scrollTop() > 32) {
                    $('.nav__phone_bg').css('height', '100%');
                    $('#header').addClass('mob_sticky');
                    $('#header .nav').css('top', '0px');
                    $('.nav__phone_wrap').addClass('col-12');
                    // $('#header .nav').css('top', `-${$('.nav__phone_wrap').height()}px`);
                    $('.js--nav').addClass('scroll');
                } else {
                    $('.nav__phone_bg').css('height', '45px');
                    $('#header').removeClass('mob_sticky');
                    $('#header .nav').css('top', 0);
                    $('.nav__phone_wrap').removeClass('col-12');
                    $('.js--nav').removeClass('scroll');
                }
            }
        },
    };
    $(document).ready(() => {
        menu.toggle();
        menu.stickyMenu();
    });
    $(document).on('scroll', menu.stickyMenu);
}());
